import { alpha, useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const CouplesTherapySummary = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box
				sx={{
					backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						theme.palette.background.default,
						0
					)} 100%)`
				}}>
				<Box
					display='flex'
					justifyContent='center'
					alignItems={'center'}
					alignContent='center'
					height={1}
					width={1}>
					<Box
						padding={2}
						width={1}
						sx={{
							bgcolor: 'rgba(0, 0, 0, 0)'
						}}
						display='flex'
						justifyContent='center'
						alignContent={'center'}
						alignItems={'center'}>
						<Container>
							<Box>
								<SimTypography
									variant='h3'
									align={'left'}
									paddingcenter='2vw'
									data-aos={'fade-up'}
									gutterBottom
									sx={{
										fontWeight: 700,
										marginTop: theme.spacing(1)
									}}>
									Couples therapy
								</SimTypography>

								<SimTypography
									color={theme.palette.primary.main}
									variant='h6'
									align={'left'}
									data-aos={'fade-up'}>
									As parents, maintain your marital bliss and balance in the journey ahead while
									taking on the responsibilities of your child
								</SimTypography>
							</Box>
						</Container>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { CouplesTherapySummary };
